var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondBnbChainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 134,
    viewBox: "0 0 135 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BNB Chain"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse",
    filter: "url(#filter0_f_1877_14984)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6781,
    cy: 27.0172,
    rx: 27.6781,
    ry: 27.0172,
    transform: "matrix(0.988288 -0.152602 0.160358 0.987059 35.3633 44.4492)",
    fill: "#CEA201",
    fillOpacity: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_14984)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6781,
    cy: 27.0172,
    rx: 27.6781,
    ry: 27.0172,
    transform: "matrix(0.988288 -0.152602 0.160358 0.987059 35.3633 44.4492)",
    fill: "#CEA201",
    fillOpacity: 0.97
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.2952 83.2111C57.5684 82.2006 55.8435 81.1676 54.1166 80.2001C53.5532 79.8826 53.2247 79.5196 52.9916 78.7248C51.9339 75.1155 50.8121 71.5119 49.7197 67.9037C49.624 67.5893 49.4553 67.261 49.5023 66.8725L52.7711 68.7668C53.1268 68.9741 53.1804 69.3761 53.287 69.7263C53.8812 71.6784 54.5836 73.6351 55.0385 75.5813C55.3522 76.929 56.0437 77.5232 56.8398 77.9036C58.4079 78.6523 59.9372 79.7397 61.4967 80.5178C61.7834 80.6617 61.8706 80.9483 61.9633 81.2528C62.3661 82.5761 62.7683 83.8974 63.2238 85.3938L59.3735 83.2858C59.3725 83.275 59.3692 83.2637 59.364 83.2531C59.3589 83.2425 59.352 83.2329 59.3441 83.2254C59.3362 83.2178 59.3275 83.2125 59.3189 83.21C59.3103 83.2075 59.3022 83.2079 59.2952 83.2111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.4542 53.0304C74.6994 53.8684 73.9304 54.6911 73.1971 55.5557C72.9124 55.8904 72.6329 56.0055 72.0949 55.7085C69.9505 54.5268 67.7969 53.4214 65.6518 52.2374C65.1421 51.9545 64.8417 51.9465 64.5338 52.3043C63.3506 53.6893 62.1043 54.9994 60.9219 56.3867C60.4964 56.8934 60.0711 57.0725 59.2725 56.5756C58.1248 55.8531 56.9315 55.283 55.76 54.6474C57.792 52.3828 59.7535 50.059 61.784 47.7898C61.8642 47.6714 61.9997 47.5948 62.05 47.4487C62.736 46.4797 63.5542 46.5107 64.9439 47.3497C66.641 48.387 69.2394 49.8841 69.8321 50.1392C69.9517 50.2053 70.2584 50.364 70.3297 50.4022C72.0733 51.335 73.4323 52.1074 75.0446 52.7747L75.4542 53.0304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.4558 86.7265C70.6589 87.4087 71.821 88.0356 72.4491 86.8481L72.6814 86.4616C73.5749 84.6981 73.8896 84.461 72.9243 82.042C72.0756 79.9151 72.0616 79.7765 71.1236 81.1443C70.2142 82.4776 69.2157 82.7296 67.4006 81.5147C65.5855 80.2998 65.5431 80.4754 66.2615 82.714C67.1436 85.4642 67.154 85.4096 69.4558 86.7265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.9461 74.0098C65.5868 72.9087 65.2037 71.8095 64.8772 70.7036C64.6884 70.07 64.4082 69.7665 63.8697 69.4866C61.9623 68.5076 60.0652 67.4154 58.1588 66.4046C57.9776 66.33 57.8018 66.192 57.6572 66.0109C57.5126 65.8297 57.4069 65.6148 57.3554 65.3976C56.9917 64.1929 56.5949 62.9867 56.1772 61.7865C56.0947 61.5871 56.0618 61.3817 56.0833 61.2007C56.1048 61.0197 56.1795 60.8728 56.2965 60.7814C56.9182 60.1357 57.5216 59.4639 58.096 58.7584C58.3483 58.451 58.6291 58.4765 59.0448 58.7051C60.977 59.7647 62.9133 60.7773 64.8386 61.8311C65.2627 62.0654 65.5123 62.0701 65.7714 61.7685C66.8863 60.4835 68.0579 59.2722 69.1624 57.9753C69.5185 57.5659 69.8525 57.4342 70.4432 57.8689C70.787 58.1332 71.1426 58.3571 71.5031 58.5363C72.2695 58.8843 73.3325 59.0761 73.6923 59.8037C74.4171 61.2649 74.7763 62.871 75.2764 64.4187C75.3909 64.7699 75.1291 64.8278 75.0024 64.9698C73.8926 66.2205 72.7962 67.4871 71.6436 68.6819C71.2369 69.1061 71.1615 69.5452 71.4425 70.3515C72.2096 72.5476 72.8788 74.7539 73.6232 76.9603C73.8166 77.5532 73.8259 77.9619 73.4735 78.2225C73.3992 78.2909 73.3309 78.3675 73.2692 78.4516C71.1878 80.7463 71.1869 80.7337 67.7485 78.5388C67.3692 78.2965 67.2297 77.9941 67.103 77.6057C66.71 76.4013 66.3177 75.199 65.9248 73.9946L65.9461 74.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M79.6764 82.2643C79.2332 80.8093 78.8283 79.4511 78.4068 78.0965C78.2856 77.6984 78.3552 77.5184 78.5304 77.3146C79.5866 76.0749 80.6095 74.7933 81.6743 73.5673C81.8111 73.4454 81.8978 73.2546 81.9223 73.0216C81.9467 72.7887 81.9076 72.5254 81.8104 72.269C81.1193 70.0818 80.4766 67.8902 79.7969 65.7163C79.7048 65.4748 79.6683 65.2267 79.6925 65.008C79.7167 64.7892 79.8005 64.6112 79.9316 64.4999C80.5395 63.832 81.102 63.111 81.6702 62.4283C81.9261 62.5567 81.9341 62.785 81.9887 62.9641C83.1582 66.8036 84.3206 70.6436 85.5086 74.4814C85.5938 74.7043 85.6288 74.9335 85.6089 75.1369C85.5889 75.3403 85.5149 75.5078 85.3973 75.6159C83.5648 77.7736 81.7566 79.9536 79.9378 82.1223C79.8575 82.1824 79.7699 82.23 79.6764 82.2643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M75.8686 55.2535C76.644 54.3691 77.3483 53.5891 78.0267 52.7778C78.2114 52.5527 78.4274 52.6622 78.6816 52.8021C79.6749 53.3465 80.6695 53.9098 81.6692 54.4348C82.0935 54.6545 82.292 54.9813 82.4384 55.4716C82.7637 56.5584 83.0903 57.6493 83.4941 58.7337C83.6018 58.9921 83.6493 59.2592 83.6299 59.4985C83.6105 59.7378 83.5253 59.9376 83.3858 60.0707C82.8348 60.7205 82.2514 61.329 81.7041 61.9805C81.4252 62.312 81.2823 62.0895 81.1415 61.651C80.7931 60.5662 80.4239 59.481 80.0936 58.3883C79.906 57.7548 79.6768 57.3574 79.0863 57.0742C78.0727 56.5754 77.0612 55.9298 75.8686 55.2535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M54.865 58.9569C54.2091 59.7015 53.7021 60.3812 53.1009 60.9306C52.645 61.3441 52.4872 61.8016 52.8209 62.6869C53.2042 63.7021 53.4763 64.7267 53.8163 65.7455C53.9946 66.3003 53.9811 66.5298 53.4304 66.2139C52.4611 65.6672 51.4951 65.1306 50.5224 64.6324C50.1802 64.4518 50.038 64.2019 49.9264 63.8446C49.5227 62.5881 49.1344 61.3303 48.7152 60.0751C48.6439 59.8926 48.6167 59.7058 48.6374 59.5416C48.6582 59.3773 48.7259 59.2439 48.8308 59.1603C49.4624 58.4784 50.0794 57.7706 50.6838 57.0533C50.7455 56.9555 50.8395 56.8963 50.9522 56.8842C51.0649 56.872 51.1906 56.9076 51.3112 56.9857C52.4345 57.6116 53.5657 58.2327 54.865 58.9569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M56.8207 70.2145C58.0698 70.9358 59.1589 71.5711 60.2507 72.1959C60.5052 72.341 60.5832 72.5919 60.6647 72.8588C61.0297 74.054 61.3876 75.2499 61.7626 76.4298C61.958 77.0406 61.7608 77.0111 61.3968 76.7961C60.4818 76.2639 59.5627 75.7136 58.6431 75.2003C58.3334 75.0233 58.2062 74.7707 58.0988 74.414C57.7028 73.0885 57.2946 71.7662 56.8207 70.2145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M75.8549 72.1537C74.9372 70.3858 75.2534 69.3309 76.2122 68.5972C76.5269 68.364 76.7392 67.9591 77.0202 67.6652C77.2829 67.3894 77.5106 67.4597 77.6902 68.0703C78.0224 69.201 78.3711 70.3301 78.7363 71.4579C78.7984 71.6204 78.8239 71.7872 78.8094 71.9355C78.7948 72.0838 78.7408 72.2065 78.6548 72.2867C78.0884 72.9406 77.5295 73.6061 76.9783 74.2833C76.7238 74.5954 76.5609 74.4886 76.4077 73.9536C76.2343 73.3486 76.0395 72.7516 75.8549 72.1537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M62.2959 57.5828C63.049 56.7413 63.7487 56.0807 64.3266 55.2803C64.745 54.6941 65.23 54.7842 65.9388 55.2249C66.9728 55.8693 68.048 56.2757 69.1686 57.0851L66.8375 59.6669C66.7746 59.74 66.6879 59.7819 66.5876 59.7877C66.4873 59.7935 66.3775 59.763 66.271 59.6997C64.9962 59.0257 63.7284 58.3467 62.2959 57.5828Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14984",
    x: 0.0515633,
    y: 0.590626,
    width: 133.998,
    height: 132.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14984"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14984",
    x: 0.0515633,
    y: 0.590626,
    width: 133.998,
    height: 132.608,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.65,
    result: "effect1_foregroundBlur_1877_14984"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondBnbChainIcon);
export default __webpack_public_path__ + "static/media/SecondBNBChainIcon.82774fc3b00f75789ab29ecaae6025d7.svg";
export { ForwardRef as ReactComponent };